import { USER_EXCHANGE_CODES } from "./const";

/**
 * @param {UserExchange} form
 * @returns {UserExchange}
 */
export function initUserExchange(form) {
    form = {
        ...(form || {}),

        _id: form?._id,

        _member: form?._member,
        _giftee: form?._giftee,
        giftee: form?.giftee,

        _bulk: form?._bulk,
        _gift: form?._gift,
        _cash: form?._cash,

        ip: form?.ip,
        tid: form?.tid,
        code: form?.code || USER_EXCHANGE_CODES.AUCTION.value,
        prev: form?.prev || null,
        next: form?.next || null,
        name: form?.name || null,
        type: form?.type,
        amount: form?.amount || 0,

        done: form?.done ?? false,
        fail: form?.fail ?? false,

        cashed: form?.cashed ?? false,
        gifted: form?.gifted ?? false,
        undone: form?.undone ?? false,

        failedToCash: form?.failedToCash ?? false,
        failedToGift: form?.failedToGift ?? false,

        errorMessage: form?.errorMessage || null,

        createdAt: form?.createdAt,

        tempId: form?.tempId ?? `${Math.random()}`.slice(2, 18),
    };

    if (!form._id) delete form._id;
    if (!form._member) delete form._member;
    if (!form._giftee) delete form._giftee;
    if (!form.giftee) delete form.giftee;
    if (!form._bulk) delete form._bulk;
    if (!form._gift) delete form._gift;
    if (!form._cash) delete form._cash;
    if (!form.ip) delete form.ip;
    if (!form.tid) delete form.tid;
    if (!form.type) delete form.type;
    if (!form.createdAt) delete form.createdAt;

    return form;
}

/**
 * @typedef UserExchange
 *
 * @property {string} [_id]
 *
 * @property {string} [_member]
 *
 * @property {string} [_giftee]
 * @property {object} [giftee]
 *
 * @property {string} [_bulk]
 * @property {string} [_gift]
 * @property {string} [_cash]
 *
 * @property {string} [ip]
 * @property {string} [tid]
 * @property {keyof USER_EXCHANGE_CODES} code
 * @property {string|null} prev
 * @property {string|null} next
 * @property {string|null} name
 * @property {string} [type]
 * @property {number} amount
 *
 * @property {boolean} done
 * @property {boolean} fail
 *
 * @property {boolean} cashed
 * @property {boolean} gifted
 * @property {boolean} undone
 *
 * @property {boolean} failedToCash
 * @property {boolean} failedToGift
 * 
 * @property {string|null} errorMessage
 *
 * @property {string} [createdAt]
 *
 * @property {string} [tempId]
 */
